import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';

export interface IJoinUsProps extends IBaseElementProps {
	image?: IImage;
	heading?: string;
	text?: string;
	link?: ILink;
	tagline?: string;
}

/**
 * Join Us
 * @block
 * @requiresHooks
 * @icon groups
 */


const JoinUs: React.FC<IJoinUsProps> = ({
	image,
	heading,
	text,
	link,
	tagline,
}) => (
	<div className="join-us">
		<div className="join-us__container">
			{image && (
				<div className="join-us__logo">
					<Image
						{...image}
					/>
				</div>
			)}
			{heading && <h2 className="join-us__heading">{heading}</h2>}
			{text && <div className="join-us__text">{text}</div>}
			{link && (
				<a
					className="btn btn-primary btn-lg join-us__button"
					href={link.href}
				>
					{link.label}
				</a>
			)}
			{tagline && <p className="join-us__tagline">{tagline}</p>}
		</div>
	</div>
);

export default JoinUs;
